module.exports = __webpack_public_path__ + "57965a383e0ccee658cb43c999603c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/promo-and-button-modal-window/icon-open-black.png
// module id = 805
// module chunks = 0 1